/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PatientGuarantorAddress } from './PatientGuarantorAddress';
import type { SimplePatient } from './SimplePatient';

export type PatientGuarantor = {
    readonly id?: number;
    readonly patient?: SimplePatient;
    readonly address?: PatientGuarantorAddress;
    first_name?: string | null;
    middle_initial?: string | null;
    /**
     * space separated list of middle names
     */
    middle_names?: string | null;
    last_name?: string | null;
    phone?: string | null;
    work_phone?: string | null;
    relationship_to_patient?: string | null;
    readonly created_at?: string;
    readonly updated_at?: string;
    date_of_birth?: string | null;
    /**
     * HL7 single character representation of sex: F, M, O, U, A
     */
    sex?: PatientGuarantor.sex | null;
    ssn?: string | null;
}

export namespace PatientGuarantor {

    /**
     * HL7 single character representation of sex: F, M, O, U, A
     */
    export enum sex {
        M = 'M',
        F = 'F',
        O = 'O',
        U = 'U',
        A = 'A',
    }


}
